import styled from "@emotion/styled";

export const FeatureImage = styled.img(() => ({
  width: "39.5%",
  marginTop: "1.3%",
  maxWidth: "100%",
  height: "auto",
}));
